import { IonTitle } from '@ionic/react';
import styled from 'styled-components';
import { typography } from 'styled-system';
const GrapeTitle = styled(IonTitle) `
  ${typography}
`;
GrapeTitle.defaultProps = {
    fontFamily: 'var(--title-font-family)',
};
export { GrapeTitle };
//# sourceMappingURL=index.js.map